export default {
  getCleanAddress(address) {
    const start = address.indexOf("<");
    const end = address.indexOf(">");
    if (start >= 0 && end >= 0) {
      return address.substring(start + 1, end);
    }
    return address;
  },
};
